addEventListener("DOMContentLoaded", () => {
	let header = document.querySelector('header.shopify-section');
	let headerLeft = header.querySelector('.header__column--left');
	let {left, right} = headerLeft.getBoundingClientRect();
	header.style.setProperty('--offset', `${(window.innerWidth - right - left)/2}px`);



    /* open insta links in new tab */
    addEventListener("click", e => {
	    let a = e.target.closest('a');
	    if (a && a.hostname.includes('instagram.com')) {
		    e.preventDefault();
		    window.open(a.href, '_blank', 'noopener,noreferrer');
	    }
    });

	document.querySelectorAll('footer rte-formatter p')
		.forEach(block => block.textContent = block.textContent.replace(/\d{4}/, new Date().getFullYear()));
});